import axiosInstance from './axiosInstance'

export const getExistingSignOptionById = (optionId) => {
  return axiosInstance.get(`/existing-sign-options/${optionId}`)
}

export const getExistingSignOptions = (page = 1, limit = 50, search = '', orderByKey = 'id', direction = 'asc') => {
  return axiosInstance.get(`/existing-sign-options?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
}

export const createExistingSignOption = (data) => {
  return axiosInstance.post('/existing-sign-options', data)
}

export const updateExistingSignOption = (optionId, data) => {
  return axiosInstance.put(`/existing-sign-options/${optionId}`, data)
}

export const deleteExistingSignOption = (optionId) => {
  return axiosInstance.delete(`/existing-sign-options/${optionId}`)
}
